angular
    .module("skillBuilderSaaS")
    .directive("iframeSetDimensionsOnload", ([function () {
        return {
            restrict: "A",
            link: function (_scope, element) {
                var eventMethod = window.addEventListener ? "addEventListener" : "attachEvent";
                var eventer = window[eventMethod];
                var messageEvent = eventMethod === "attachEvent" ? "onmessage" : "message";
                var height;
                // Listen for a message from the iframe.
                eventer(messageEvent, function (e) {
                    if (isNaN(e.data))
                        return;
                    height = e.data + 90;
                }, false);
                element.on("load", function () {
                    element.css("height", height + 'px');
                });
            }
        };
    }]));
